import promptingsCoachDiscountFragmentRawString from '../PromptingsCoachDiscountFragment.graphql'

export const promptingsCoachDiscountFragmentString = promptingsCoachDiscountFragmentRawString

export type PromptingsCoachDiscountFragment = {
  __typename: 'PromptingsCoachDiscount'
  code: string
  eventbriteGroupId: string
  expirationDatetime: string
  isUsed: boolean
  amountOff: number
  percentOff: number
}

export const isPromptingsCoachDiscountFragment = (
  fragment: any,
): fragment is PromptingsCoachDiscountFragment =>
  fragment &&
  fragment.__typename === 'PromptingsCoachDiscount' &&
  typeof fragment.code === 'string' &&
  typeof fragment.eventbriteGroupId === 'string' &&
  typeof fragment.expirationDatetime === 'string' &&
  typeof fragment.isUsed === 'boolean' &&
  typeof fragment.amountOff === 'number' &&
  typeof fragment.percentOff === 'number'
